export const LOGO_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_auto-connect-118/artifacts/d9ljh9li_image.png";

// L'image du logo contient déjà le mot-clé "PLAN PERMIS" sur fond blanc.
// Sur fond clair : on affiche l'image (mix-blend-multiply pour absorber le fond blanc).
// Sur fond sombre : on affiche le wordmark typographique.
export const Logo = ({ className = "h-12", dark = false, testId = "logo" }) => {
  if (dark) {
    return (
      <span data-testid={testId} className="font-display text-2xl font-extrabold tracking-tight text-white">
        Plan<span className="text-brand">Permis</span>
      </span>
    );
  }
  return (
    <img
      data-testid={testId}
      src={LOGO_URL}
      alt="PlanPermis"
      className={`${className} w-auto object-contain mix-blend-multiply`}
    />
  );
};

// Vrai logo affiché dans une pastille blanche : lisible sur fond sombre (navy).
export const RealLogo = ({ className = "h-11", testId = "logo-real" }) => (
  <span className="inline-flex items-center rounded-2xl bg-white px-4 py-2.5 shadow-lg shadow-black/20 ring-1 ring-black/5">
    <img
      data-testid={testId}
      src={LOGO_URL}
      alt="PlanPermis"
      className={`${className} w-auto object-contain`}
    />
  </span>
);
